module.exports = __webpack_public_path__ + "static/sometimes_i_sit-24562231447ffa3fe47e781c5002a515.png";